<template>
  <toast class="position-translate-center bg-toast-danger border-danger" ref="toast">
    <toast-body :message="message" />
  </toast>
</template>
  
  <script>
  import Toast from '@/views/atoms/Toast'
  import ToastBody from '@/views/atoms/ToastBody'
  
  export default {
    name: "MessageErrorToast",
    components: {
      Toast,
      ToastBody,
    },
    data() {
      return {
        message: null,
      }
    },
    methods: {
        show(message) {
            this.message = message;
            this.$refs.toast.show();
        },
    },
  }
  </script>
  
  <style scoped>
  .toast {
    width: 400px;
  }
  </style>
  